export type presetColorsObject = {
  name: string,
  value: string
}

// Default roof outline color for new quotes is White
export const DEFAULT_ROOF_OUTLINE_COLOR = '#FFFFFF';

export const PRESET_COLORS_DEFAULT: presetColorsObject[] = [
  {
    name: 'White',
    value: '#FFFFFF',
  },
  {
    name: 'Purple',
    value: '#4B0082',
  },
  {
    name: 'Yellow',
    value: '#EDFF24',
  }
];

/**
 * Gets the default roof outline color for new quotes.
 * Always returns White (#FFFFFF) as the default for new quotes.
 * Color preference within a quote session is managed by NgRx store.
 */
export function getDefaultRoofOutlineColor(): presetColorsObject {
  // Default to White (#FFFFFF) - the first color in the array
  return PRESET_COLORS_DEFAULT[0];
}

/**
 * Gets a color object by its hex value from the preset colors.
 * Falls back to the default color if not found.
 */
export function getColorByValue(colorValue: string): presetColorsObject {
  return PRESET_COLORS_DEFAULT.find(c => c.value === colorValue) ?? getDefaultRoofOutlineColor();
}